import lodash from 'lodash-es'
const nafCodes = new Vue({
  data() {
    return {
      options: [
        {
          id: '01.11Z',
          label:
            "0111Z-Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses",
        },
        { id: '01.12Z', label: '0112Z-Culture du riz' },
        {
          id: '01.13Z',
          label:
            '0113Z-Culture de légumes, de melons, de racines et de tubercules',
        },
        { id: '01.14Z', label: '0114Z-Culture de la canne à sucre' },
        { id: '01.15Z', label: '0115Z-Culture du tabac' },
        { id: '01.16Z', label: '0116Z-Culture de plantes à fibres' },
        { id: '01.19Z', label: '0119Z-Autres cultures non permanentes' },
        { id: '01.21Z', label: '0121Z-Culture de la vigne' },
        {
          id: '01.22Z',
          label: '0122Z-Culture de fruits tropicaux et subtropicaux',
        },
        { id: '01.23Z', label: "0123Z-Culture d'agrumes" },
        { id: '01.24Z', label: '0124Z-Culture de fruits à pépins et à noyau' },
        {
          id: '01.25Z',
          label:
            "0125Z-Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque",
        },
        { id: '01.26Z', label: '0126Z-Culture de fruits oléagineux' },
        { id: '01.27Z', label: '0127Z-Culture de plantes à boissons' },
        {
          id: '01.28Z',
          label:
            '0128Z-Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques',
        },
        { id: '01.29Z', label: '0129Z-Autres cultures permanentes' },
        { id: '01.30Z', label: '0130Z-Reproduction de plantes' },
        { id: '01.41Z', label: '0141Z-Élevage de vaches laitières' },
        { id: '01.42Z', label: "0142Z-Élevage d'autres bovins et de buffles" },
        { id: '01.43Z', label: "0143Z-Élevage de chevaux et d'autres équidés" },
        {
          id: '01.44Z',
          label: "0144Z-Élevage de chameaux et d'autres camélidés",
        },
        { id: '01.45Z', label: "0145Z-Élevage d'ovins et de caprins" },
        { id: '01.46Z', label: '0146Z-Élevage de porcins' },
        { id: '01.47Z', label: '0147Z-Élevage de volailles' },
        { id: '01.49Z', label: "0149Z-Élevage d'autres animaux" },
        { id: '01.50Z', label: '0150Z-Culture et élevage associés' },
        { id: '01.61Z', label: '0161Z-Activités de soutien aux cultures' },
        {
          id: '01.62Z',
          label: '0162Z-Activités de soutien à la production animale',
        },
        { id: '01.63Z', label: '0163Z-Traitement primaire des récoltes' },
        { id: '01.64Z', label: '0164Z-Traitement des semences' },
        { id: '01.70Z', label: '0170Z-Chasse, piégeage et services annexes' },
        {
          id: '02.10Z',
          label: '0210Z-Sylviculture et autres activités forestières',
        },
        { id: '02.20Z', label: '0220Z-Exploitation forestière' },
        {
          id: '02.30Z',
          label:
            "0230Z-Récolte de produits forestiers non ligneux poussant à l'état sauvage",
        },
        {
          id: '02.40Z',
          label: "0240Z-Services de soutien à l'exploitation forestière",
        },
        { id: '03.11Z', label: '0311Z-Pêche en mer' },
        { id: '03.12Z', label: '0312Z-Pêche en eau douce' },
        { id: '03.21Z', label: '0321Z-Aquaculture en mer' },
        { id: '03.22Z', label: '0322Z-Aquaculture en eau douce' },
        { id: '05.10Z', label: '0510Z-Extraction de houille' },
        { id: '05.20Z', label: '0520Z-Extraction de lignite' },
        { id: '06.10Z', label: '0610Z-Extraction de pétrole brut' },
        { id: '06.20Z', label: '0620Z-Extraction de gaz naturel' },
        { id: '07.10Z', label: '0710Z-Extraction de minerais de fer' },
        {
          id: '07.21Z',
          label: "0721Z-Extraction de minerais d'uranium et de thorium",
        },
        {
          id: '07.29Z',
          label: "0729Z-Extraction d'autres minerais de métaux non ferreux",
        },
        {
          id: '08.11Z',
          label:
            "0811Z-Extraction de pierres ornementales et de construction, de calcaire industriel, de gypse, de craie et d'ardoise",
        },
        {
          id: '08.12Z',
          label:
            '0812Z-Exploitation de gravières et sablières, extraction d’argiles et de kaolin',
        },
        {
          id: '08.91Z',
          label:
            "0891Z-Extraction des minéraux chimiques et d'engrais minéraux",
        },
        { id: '08.92Z', label: '0892Z-Extraction de tourbe' },
        { id: '08.93Z', label: '0893Z-Production de sel' },
        { id: '08.99Z', label: '0899Z-Autres activités extractives nca' },
        {
          id: '09.10Z',
          label: "0910Z-Activités de soutien à l'extraction d'hydrocarbures",
        },
        {
          id: '09.90Z',
          label: '0990Z-Activités de soutien aux autres industries extractives',
        },
        {
          id: '10.11Z',
          label:
            '1011Z-Transformation et conservation de la viande de boucherie',
        },
        {
          id: '10.12Z',
          label:
            '1012Z-Transformation et conservation de la viande de volaille',
        },
        {
          id: '10.13A',
          label: '1013A-Préparation industrielle de produits à base de viande',
        },
        { id: '10.13B', label: '1013B-Charcuterie' },
        {
          id: '10.20Z',
          label:
            '1020Z-Transformation et conservation de poisson, de crustacés et de mollusques',
        },
        {
          id: '10.31Z',
          label: '1031Z-Transformation et conservation de pommes de terre',
        },
        {
          id: '10.32Z',
          label: '1032Z-Préparation de jus de fruits et légumes',
        },
        {
          id: '10.39A',
          label: '1039A-Autre transformation et conservation de légumes',
        },
        {
          id: '10.39B',
          label: '1039B-Transformation et conservation de fruits',
        },
        {
          id: '10.41A',
          label: "1041A-Fabrication d'huiles et graisses brutes",
        },
        {
          id: '10.41B',
          label: "1041B-Fabrication d'huiles et graisses raffinées",
        },
        {
          id: '10.42Z',
          label:
            '1042Z-Fabrication de margarine et graisses comestibles similaires',
        },
        {
          id: '10.51A',
          label: '1051A-Fabrication de lait liquide et de produits frais',
        },
        { id: '10.51B', label: '1051B-Fabrication de beurre' },
        { id: '10.51C', label: '1051C-Fabrication de fromage' },
        { id: '10.51D', label: "1051D-Fabrication d'autres produits laitiers" },
        { id: '10.52Z', label: '1052Z-Fabrication de glaces et sorbets' },
        { id: '10.61A', label: '1061A-Meunerie' },
        { id: '10.61B', label: '1061B-Autres activités du travail des grains' },
        { id: '10.62Z', label: '1062Z-Fabrication de produits amylacés' },
        {
          id: '10.71A',
          label:
            '1071A-Fabrication industrielle de pain et de pâtisserie fraîche',
        },
        { id: '10.71B', label: '1071B-Cuisson de produits de boulangerie' },
        { id: '10.71C', label: '1071C-Boulangerie et boulangerie-pâtisserie' },
        { id: '10.71D', label: '1071D-Pâtisserie' },
        {
          id: '10.72Z',
          label:
            '1072Z-Fabrication de biscuits, biscottes et pâtisseries de conservation',
        },
        { id: '10.73Z', label: '1073Z-Fabrication de pâtes alimentaires' },
        { id: '10.81Z', label: '1081Z-Fabrication de sucre' },
        {
          id: '10.82Z',
          label:
            '1082Z-Fabrication de cacao, chocolat et de produits de confiserie',
        },
        { id: '10.83Z', label: '1083Z-Transformation du thé et du café' },
        {
          id: '10.84Z',
          label: '1084Z-Fabrication de condiments et assaisonnements',
        },
        { id: '10.85Z', label: '1085Z-Fabrication de plats préparés' },
        {
          id: '10.86Z',
          label: "1086Z-Fabrication d'aliments homogénéisés et diététiques",
        },
        {
          id: '10.89Z',
          label: "1089Z-Fabrication d'autres produits alimentaires nca",
        },
        {
          id: '10.91Z',
          label: "1091Z-Fabrication d'aliments pour animaux de ferme",
        },
        {
          id: '10.92Z',
          label: "1092Z-Fabrication d'aliments pour animaux de compagnie",
        },
        {
          id: '11.01Z',
          label: '1101Z-Production de boissons alcooliques distillées',
        },
        { id: '11.02A', label: '1102A-Fabrication de vins effervescents' },
        { id: '11.02B', label: '1102B-Vinification' },
        {
          id: '11.03Z',
          label: '1103Z-Fabrication de cidre et de vins de fruits',
        },
        {
          id: '11.04Z',
          label: "1104Z-Production d'autres boissons fermentées non distillées",
        },
        { id: '11.05Z', label: '1105Z-Fabrication de bière' },
        { id: '11.06Z', label: '1106Z-Fabrication de malt' },
        { id: '11.07A', label: '1107A-Industrie des eaux de table' },
        {
          id: '11.07B',
          label: '1107B-Production de boissons rafraîchissantes',
        },
        {
          id: '12.00Z',
          label: '1200Z-Fabrication de produits à base de tabac',
        },
        {
          id: '13.10Z',
          label: '1310Z-Préparation de fibres textiles et filature',
        },
        { id: '13.20Z', label: '1320Z-Tissage' },
        { id: '13.30Z', label: '1330Z-Ennoblissement textile' },
        { id: '13.91Z', label: "1391Z-Fabrication d'étoffes à mailles" },
        {
          id: '13.92Z',
          label: "1392Z-Fabrication d'articles textiles, sauf habillement",
        },
        { id: '13.93Z', label: '1393Z-Fabrication de tapis et moquettes' },
        {
          id: '13.94Z',
          label: '1394Z-Fabrication de ficelles, cordes et filets',
        },
        {
          id: '13.95Z',
          label: '1395Z-Fabrication de non-tissés, sauf habillement',
        },
        {
          id: '13.96Z',
          label:
            "1396Z-Fabrication d'autres textiles techniques et industriels",
        },
        { id: '13.99Z', label: "1399Z-Fabrication d'autres textiles nca" },
        { id: '14.11Z', label: '1411Z-Fabrication de vêtements en cuir' },
        { id: '14.12Z', label: '1412Z-Fabrication de vêtements de travail' },
        { id: '14.13Z', label: '1413Z-Fabrication de vêtements de dessus' },
        { id: '14.14Z', label: '1414Z-Fabrication de vêtements de dessous' },
        {
          id: '14.19Z',
          label: "1419Z-Fabrication d'autres vêtements et accessoires",
        },
        { id: '14.20Z', label: "1420Z-Fabrication d'articles en fourrure" },
        {
          id: '14.31Z',
          label: "1431Z-Fabrication d'articles chaussants à mailles",
        },
        {
          id: '14.39Z',
          label: "1439Z-Fabrication d'autres articles à mailles",
        },
        {
          id: '15.11Z',
          label:
            '1511Z-Apprêt et tannage des cuirs ; préparation et teinture des fourrures',
        },
        {
          id: '15.12Z',
          label:
            "1512Z-Fabrication d'articles de voyage, de maroquinerie et de sellerie",
        },
        { id: '15.20Z', label: '1520Z-Fabrication de chaussures' },
        {
          id: '16.10A',
          label: '1610A-Sciage et rabotage du bois, hors imprégnation',
        },
        { id: '16.10B', label: '1610B-Imprégnation du bois' },
        {
          id: '16.21Z',
          label: '1621Z-Fabrication de placage et de panneaux de bois',
        },
        { id: '16.22Z', label: '1622Z-Fabrication de parquets assemblés' },
        {
          id: '16.23Z,',
          label: "1623Z-Fabrication de charpentes et d'autres menuiseries",
        },
        { id: '16.24Z', label: "1624Z-Fabrication d'emballages en bois" },
        {
          id: '16.29Z',
          label:
            "1629Z-Fabrication d'objets divers en bois ; fabrication d'objets en liège, vannerie et sparterie",
        },
        { id: '17.11Z,', label: '1711Z-Fabrication de pâte à papier' },
        { id: '17.12Z,', label: '1712Z-Fabrication de papier et de carton' },
        { id: '17.21A', label: '1721A-Fabrication de carton ondulé' },
        { id: '17.21B', label: '1721B-Fabrication de cartonnages' },
        { id: '17.21C', label: "1721C-Fabrication d'emballages en papier" },
        {
          id: '17.22Z',
          label:
            "1722Z-Fabrication d'articles en papier à usage sanitaire ou domestique",
        },
        { id: '17.23Z', label: "1723Z-Fabrication d'articles de papeterie" },
        { id: '17.24Z', label: '1724Z-Fabrication de papiers peints' },
        {
          id: '17.29Z',
          label: "1729Z-Fabrication d'autres articles en papier ou en carton",
        },
        { id: '18.11Z', label: '1811Z-Imprimerie de journaux' },
        { id: '18.12Z', label: '1812Z-Autre imprimerie (labeur)' },
        { id: '18.13Z', label: '1813Z-Activités de pré-presse' },
        { id: '18.14Z', label: '1814Z-Reliure et activités connexes' },
        { id: '18.20Z', label: "1820Z-Reproduction d'enregistrements" },
        { id: '19.10Z', label: '1910Z-Cokéfaction' },
        { id: '19.20Z', label: '1920Z-Raffinage du pétrole' },
        { id: '20.11Z', label: '2011Z-Fabrication de gaz industriels' },
        {
          id: '20.12Z',
          label: '2012Z-Fabrication de colorants et de pigments',
        },
        {
          id: '20.13A',
          label: '2013A-Enrichissement et retraitement de matières nucléaires',
        },
        {
          id: '20.13B',
          label:
            "2013B-Fabrication d'autres produits chimiques inorganiques de base nca",
        },
        {
          id: '20.14Z',
          label:
            "2014Z-Fabrication d'autres produits chimiques organiques de base",
        },
        {
          id: '20.15Z',
          label: "2015Z-Fabrication de produits azotés et d'engrais",
        },
        {
          id: '20.16Z',
          label: '2016Z-Fabrication de matières plastiques de base',
        },
        { id: '20.17Z', label: '2017Z-Fabrication de caoutchouc synthétique' },
        {
          id: '20.20Z',
          label:
            '2020Z-Fabrication de pesticides et d’autres produits agrochimiques',
        },
        {
          id: '20.30Z',
          label: '2030Z-Fabrication de peintures, vernis, encres et mastics',
        },
        {
          id: '20.41Z',
          label:
            "2041Z-Fabrication de savons, détergents et produits d'entretien",
        },
        {
          id: '20.42Z',
          label: '2042Z-Fabrication de parfums et de produits pour la toilette',
        },
        { id: '20.51Z', label: '2051Z-Fabrication de produits explosifs' },
        { id: '20.52Z', label: '2052Z-Fabrication de colles' },
        { id: '20.53Z', label: "2053Z-Fabrication d'huiles essentielles" },
        {
          id: '20.59Z',
          label: "2059Z-Fabrication d'autres produits chimiques nca",
        },
        {
          id: '20.60Z',
          label: '2060Z-Fabrication de fibres artificielles ou synthétiques',
        },
        {
          id: '21.10Z',
          label: '2110Z-Fabrication de produits pharmaceutiques de base',
        },
        {
          id: '21.20Z',
          label: '2120Z-Fabrication de préparations pharmaceutiques',
        },
        {
          id: '22.11Z',
          label: '2211Z-Fabrication et rechapage de pneumatiques',
        },
        {
          id: '22.19Z',
          label: "2219Z-Fabrication d'autres articles en caoutchouc",
        },
        {
          id: '22.21Z',
          label:
            '2221Z-Fabrication de plaques, feuilles, tubes et profilés en matières plastiques',
        },
        {
          id: '22.22Z',
          label: "2222Z-Fabrication d'emballages en matières plastiques",
        },
        {
          id: '22.23Z',
          label:
            "2223Z-Fabrication d'éléments en matières plastiques pour la construction",
        },
        {
          id: '22.29A',
          label:
            '2229A-Fabrication de pièces techniques à base de matières plastiques',
        },
        {
          id: '22.29B',
          label:
            '2229B-Fabrication de produits de consommation courante en matières plastiques',
        },
        { id: '23.11Z', label: '2311Z-Fabrication de verre plat' },
        {
          id: '23.12Z',
          label: '2312Z-Façonnage et transformation du verre plat',
        },
        { id: '23.13Z', label: '2313Z-Fabrication de verre creux' },
        { id: '23.14Z', label: '2314Z-Fabrication de fibres de verre' },
        {
          id: '23.19Z',
          label:
            "2319Z-Fabrication et façonnage d'autres articles en verre, y compris verre technique",
        },
        { id: '23.20Z', label: '2320Z-Fabrication de produits réfractaires' },
        { id: '23.31Z', label: '2331Z-Fabrication de carreaux en céramique' },
        {
          id: '23.32Z',
          label:
            '2332Z-Fabrication de briques, tuiles et produits de construction, en terre cuite',
        },
        {
          id: '23.41Z',
          label:
            "2341Z-Fabrication d'articles céramiques à usage domestique ou ornemental",
        },
        {
          id: '23.42Z',
          label: "2342Z-Fabrication d'appareils sanitaires en céramique",
        },
        {
          id: '23.43Z',
          label:
            "2343Z-Fabrication d'isolateurs et pièces isolantes en céramique",
        },
        {
          id: '23.44Z',
          label:
            "2344Z-Fabrication d'autres produits céramiques à usage technique",
        },
        {
          id: '23.49Z',
          label: "2349Z-Fabrication d'autres produits céramiques",
        },
        { id: '23.51Z', label: '2351Z-Fabrication de ciment' },
        { id: '23.52Z', label: '2352Z-Fabrication de chaux et plâtre' },
        {
          id: '23.61Z',
          label: "2361Z-Fabrication d'éléments en béton pour la construction",
        },
        {
          id: '23.62Z',
          label: "2362Z-Fabrication d'éléments en plâtre pour la construction",
        },
        { id: '23.63Z', label: "2363Z-Fabrication de béton prêt à l'emploi" },
        { id: '23.64Z', label: '2364Z-Fabrication de mortiers et bétons secs' },
        { id: '23.65Z', label: "2365Z-Fabrication d'ouvrages en fibre-ciment" },
        {
          id: '23.69Z',
          label:
            "2369Z-Fabrication d'autres ouvrages en béton, en ciment ou en plâtre",
        },
        {
          id: '23.70Z',
          label: '2370Z-Taille, façonnage et finissage de pierres',
        },
        { id: '23.91Z', label: '2391Z-Fabrication de produits abrasifs' },
        {
          id: '23.99Z',
          label:
            "2399Z-Fabrication d'autres produits minéraux non métalliques nca",
        },
        { id: '24.10Z', label: '2410Z-Sidérurgie' },
        {
          id: '24.20Z',
          label:
            '2420Z-Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier',
        },
        { id: '24.31Z', label: '2431Z-Étirage à froid de barres' },
        { id: '24.32Z', label: '2432Z-Laminage à froid de feuillards' },
        {
          id: '24.33Z',
          label: '2433Z-Profilage à froid par formage ou pliage',
        },
        { id: '24.34Z', label: '2434Z-Tréfilage à froid' },
        { id: '24.41Z', label: '2441Z-Production de métaux précieux' },
        { id: '24.42Z', label: "2442Z-Métallurgie de l'aluminium" },
        {
          id: '24.43Z',
          label: "2443Z-Métallurgie du plomb, du zinc ou de l'étain",
        },
        { id: '24.44Z', label: '2444Z-Métallurgie du cuivre' },
        {
          id: '24.45Z',
          label: '2445Z-Métallurgie des autres métaux non ferreux',
        },
        {
          id: '24.46Z',
          label: '2446Z-Élaboration et transformation de matières nucléaires',
        },
        { id: '24.51Z', label: '2451Z-Fonderie de fonte' },
        { id: '24.52Z', label: "2452Z-Fonderie d'acier" },
        { id: '24.53Z', label: '2453Z-Fonderie de métaux légers' },
        { id: '24.54Z', label: "2454Z-Fonderie d'autres métaux non ferreux" },
        {
          id: '25.11Z',
          label:
            '2511Z-Fabrication de structures métalliques et de parties de structures',
        },
        {
          id: '25.12Z',
          label: '2512Z-Fabrication de portes et fenêtres en métal',
        },
        {
          id: '25.21Z',
          label:
            '2521Z-Fabrication de radiateurs et de chaudières pour le chauffage central',
        },
        {
          id: '25.29Z',
          label:
            "2529Z-Fabrication d'autres réservoirs, citernes et conteneurs métalliques",
        },
        {
          id: '25.30Z',
          label:
            "2530Z-Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
        },
        { id: '25.40Z', label: "2540Z-Fabrication d'armes et de munitions" },
        {
          id: '25.50A',
          label: '2550A-Forge, estampage, matriçage ; métallurgie des poudres',
        },
        { id: '25.50B', label: '2550B-Découpage, emboutissage' },
        { id: '25.61Z', label: '2561Z-Traitement et revêtement des métaux' },
        { id: '25.62A', label: '2562A-Décolletage' },
        { id: '25.62B', label: '2562B-Mécanique industrielle' },
        { id: '25.71Z', label: '2571Z-Fabrication de coutellerie' },
        { id: '25.72Z', label: '2572Z-Fabrication de serrures et de ferrures' },
        { id: '25.73A', label: '2573A-Fabrication de moules et modèles' },
        { id: '25.73B', label: "2573B-Fabrication d'autres outillages" },
        {
          id: '25.91Z',
          label:
            '2591Z-Fabrication de fûts et emballages métalliques similaires',
        },
        {
          id: '25.92Z',
          label: "2592Z-Fabrication d'emballages métalliques légers",
        },
        {
          id: '25.93Z',
          label:
            "2593Z-Fabrication d'articles en fils métalliques, de chaînes et de ressorts",
        },
        { id: '25.94Z', label: '2594Z-Fabrication de vis et de boulons' },
        {
          id: '25.99A',
          label: "2599A-Fabrication d'articles métalliques ménagers",
        },
        {
          id: '25.99B',
          label: "2599B-Fabrication d'autres articles métalliques",
        },
        {
          id: '26.11Z',
          label: '2611Z-Fabrication de composants électroniques',
        },
        {
          id: '26.12Z',
          label: '2612Z-Fabrication de cartes électroniques assemblées',
        },
        {
          id: '26.20Z',
          label:
            "2620Z-Fabrication d'ordinateurs et d'équipements périphériques",
        },
        {
          id: '26.30Z',
          label: "2630Z-Fabrication d'équipements de communication",
        },
        {
          id: '26.40Z',
          label: '2640Z-Fabrication de produits électroniques grand public',
        },
        {
          id: '26.51A',
          label: "2651A-Fabrication d'équipements d'aide à la navigation",
        },
        {
          id: '26.51B',
          label:
            "2651B-Fabrication d'instrumentation scientifique et technique",
        },
        { id: '26.52Z', label: '2652Z-Horlogerie' },
        {
          id: '26.60Z',
          label:
            "2660Z-Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques",
        },
        {
          id: '26.70Z',
          label: '2670Z-Fabrication de matériels optique et photographique',
        },
        {
          id: '26.80Z',
          label: '2680Z-Fabrication de supports magnétiques et optiques',
        },
        {
          id: '27.11Z',
          label:
            '2711Z-Fabrication de moteurs, génératrices et transformateurs électriques',
        },
        {
          id: '27.12Z',
          label:
            '2712Z-Fabrication de matériel de distribution et de commande électrique',
        },
        {
          id: '27.20Z',
          label: "2720Z-Fabrication de piles et d'accumulateurs électriques",
        },
        {
          id: '27.31Z',
          label: '2731Z-Fabrication de câbles de fibres optiques',
        },
        {
          id: '27.32Z',
          label:
            "2732Z-Fabrication d'autres fils et câbles électroniques ou électriques",
        },
        {
          id: '27.33Z',
          label: "2733Z-Fabrication de matériel d'installation électrique",
        },
        {
          id: '27.40Z',
          label: "2740Z-Fabrication d'appareils d'éclairage électrique",
        },
        {
          id: '27.51Z',
          label: "2751Z-Fabrication d'appareils électroménagers",
        },
        {
          id: '27.52Z',
          label: "2752Z-Fabrication d'appareils ménagers non électriques",
        },
        {
          id: '27.90Z',
          label: "2790Z-Fabrication d'autres matériels électriques",
        },
        {
          id: '28.11Z',
          label:
            "2811Z-Fabrication de moteurs et turbines, à l'exception des moteurs d’avions et de véhicules",
        },
        {
          id: '28.12Z',
          label: "2812Z-Fabrication d'équipements hydrauliques et pneumatiques",
        },
        {
          id: '28.13Z',
          label: "2813Z-Fabrication d'autres pompes et compresseurs",
        },
        {
          id: '28.14Z',
          label: "2814Z-Fabrication d'autres articles de robinetterie",
        },
        {
          id: '28.15Z',
          label:
            "2815Z-Fabrication d'engrenages et d'organes mécaniques de transmission",
        },
        { id: '28.21Z', label: '2821Z-Fabrication de fours et brûleurs' },
        {
          id: '28.22Z',
          label: '2822Z-Fabrication de matériel de levage et de manutention',
        },
        {
          id: '28.23Z',
          label:
            "2823Z-Fabrication de machines et d'équipements de bureau (à l'exception des ordinateurs et équipements périphériques)",
        },
        {
          id: '28.24Z',
          label: "2824Z-Fabrication d'outillage portatif à moteur incorporé",
        },
        {
          id: '28.25Z',
          label:
            "2825Z-Fabrication d'équipements aérauliques et frigorifiques industriels",
        },
        {
          id: '28.29A',
          label:
            "2829A-Fabrication d'équipements d'emballage, de conditionnement et de pesage",
        },
        {
          id: '28.29B',
          label: "2829B-Fabrication d'autres machines d'usage général",
        },
        {
          id: '28.30Z',
          label: '2830Z-Fabrication de machines agricoles et forestières',
        },
        {
          id: '28.41Z',
          label:
            '2841Z-Fabrication de machines-outils pour le travail des métaux',
        },
        { id: '28.49Z', label: "2849Z-Fabrication d'autres machines-outils" },
        {
          id: '28.91Z',
          label: '2891Z-Fabrication de machines pour la métallurgie',
        },
        {
          id: '28.92Z',
          label:
            "2892Z-Fabrication de machines pour l'extraction ou la construction",
        },
        {
          id: '28.93Z',
          label:
            "2893Z-Fabrication de machines pour l'industrie agro-alimentaire",
        },
        {
          id: '28.94Z',
          label: '2894Z-Fabrication de machines pour les industries textiles',
        },
        {
          id: '28.95Z',
          label:
            '2895Z-Fabrication de machines pour les industries du papier et du carton',
        },
        {
          id: '28.96Z',
          label:
            '2896Z-Fabrication de machines pour le travail du caoutchouc ou des plastiques',
        },
        { id: '28.99A', label: "2899A-Fabrication de machines d'imprimerie" },
        {
          id: '28.99B',
          label: "2899B-Fabrication d'autres machines spécialisées",
        },
        { id: '29.10Z', label: '2910Z-Construction de véhicules automobiles' },
        {
          id: '29.20Z',
          label: '2920Z-Fabrication de carrosseries et remorques',
        },
        {
          id: '29.31Z',
          label:
            "2931Z-Fabrication d'équipements électriques et électroniques automobiles",
        },
        {
          id: '29.32Z',
          label: "2932Z-Fabrication d'autres équipements automobiles",
        },
        {
          id: '30.11Z',
          label: '3011Z-Construction de navires et de structures flottantes',
        },
        { id: '30.12Z', label: '3012Z-Construction de bateaux de plaisance' },
        {
          id: '30.20Z',
          label:
            "3020Z-Construction de locomotives et d'autre matériel ferroviaire roulant",
        },
        { id: '30.30Z', label: '3030Z-Construction aéronautique et spatiale' },
        {
          id: '30.40Z',
          label: '3040Z-Construction de véhicules militaires de combat',
        },
        { id: '30.91Z', label: '3091Z-Fabrication de motocycles' },
        {
          id: '30.92Z',
          label:
            '3092Z-Fabrication de bicyclettes et de véhicules pour invalides',
        },
        {
          id: '30.99Z',
          label: '3099Z-Fabrication d’autres équipements de transport nca',
        },
        {
          id: '31.01Z',
          label: '3101Z-Fabrication de meubles de bureau et de magasin',
        },
        { id: '31.02Z', label: '3102Z-Fabrication de meubles de cuisine' },
        { id: '31.03Z', label: '3103Z-Fabrication de matelas' },
        {
          id: '31.09A',
          label: "3109A-Fabrication de sièges d'ameublement d'intérieur",
        },
        {
          id: '31.09B',
          label:
            '3109B-Fabrication d’autres meubles et industries connexes de l’ameublement',
        },
        { id: '32.11Z', label: '3211Z-Frappe de monnaie' },
        {
          id: '32.12Z',
          label: '3212Z-Fabrication d’articles de joaillerie et bijouterie',
        },
        {
          id: '32.13Z',
          label:
            '3213Z-Fabrication d’articles de bijouterie fantaisie et articles similaires',
        },
        { id: '32.20Z', label: "3220Z-Fabrication d'instruments de musique" },
        { id: '32.30Z', label: "3230Z-Fabrication d'articles de sport" },
        { id: '32.40Z', label: '3240Z-Fabrication de jeux et jouets' },
        {
          id: '32.50A',
          label: '3250A-Fabrication de matériel médico-chirurgical et dentaire',
        },
        { id: '32.50B', label: '3250B-Fabrication de lunettes' },
        { id: '32.91Z', label: '3291Z-Fabrication d’articles de brosserie' },
        { id: '32.99Z', label: '3299Z-Autres activités manufacturières nca' },
        { id: '33.11Z', label: "3311Z-Réparation d'ouvrages en métaux" },
        {
          id: '33.12Z',
          label: '3312Z-Réparation de machines et équipements mécaniques',
        },
        {
          id: '33.13Z',
          label: '3313Z-Réparation de matériels électroniques et optiques',
        },
        { id: '33.14Z', label: "3314Z-Réparation d'équipements électriques" },
        { id: '33.15Z', label: '3315Z-Réparation et maintenance navale' },
        {
          id: '33.16Z',
          label:
            "3316Z-Réparation et maintenance d'aéronefs et d'engins spatiaux",
        },
        {
          id: '33.17Z',
          label:
            "3317Z-Réparation et maintenance d'autres équipements de transport",
        },
        { id: '33.19Z', label: "3319Z-Réparation d'autres équipements" },
        {
          id: '33.20A',
          label:
            '3320A-Installation de structures métalliques, chaudronnées et de tuyauterie',
        },
        {
          id: '33.20B',
          label: '3320B-Installation de machines et équipements mécaniques',
        },
        {
          id: '33.20C',
          label:
            "3320C-Conception d'ensemble et assemblage sur site industriel d'équipements de contrôle des processus industriels",
        },
        {
          id: '33.20D',
          label:
            "3320D-Installation d'équipements électriques, de matériels électroniques et optiques ou d'autres matériels",
        },
        { id: '35.11Z', label: "3511Z-Production d'électricité" },
        { id: '35.12Z', label: "3512Z-Transport d'électricité" },
        { id: '35.13Z', label: "3513Z-Distribution d'électricité" },
        { id: '35.14Z', label: "3514Z-Commerce d'électricité" },
        { id: '35.21Z', label: '3521Z-Production de combustibles gazeux' },
        {
          id: '35.22Z',
          label: '3522Z-Distribution de combustibles gazeux par conduites',
        },
        {
          id: '35.23Z',
          label: '3523Z-Commerce de combustibles gazeux par conduites',
        },
        {
          id: '35.30Z',
          label:
            "3530Z-Production et distribution de vapeur et d'air conditionné",
        },
        {
          id: '36.00Z',
          label: "3600Z-Captage, traitement et distribution d'eau",
        },
        { id: '37.00Z', label: '3700Z-Collecte et traitement des eaux usées' },
        { id: '38.11Z', label: '3811Z-Collecte des déchets non dangereux' },
        { id: '38.12Z', label: '3812Z-Collecte des déchets dangereux' },
        {
          id: '38.21Z',
          label: '3821Z-Traitement et élimination des déchets non dangereux',
        },
        {
          id: '38.22Z',
          label: '3822Z-Traitement et élimination des déchets dangereux',
        },
        { id: '38.31Z', label: "3831Z-Démantèlement d'épaves" },
        { id: '38.32Z', label: '3832Z-Récupération de déchets triés' },
        {
          id: '39.00Z',
          label: '3900Z-Dépollution et autres services de gestion des déchets',
        },
        { id: '41.10A', label: '4110A-Promotion immobilière de logements' },
        { id: '41.10B', label: '4110B-Promotion immobilière de bureaux' },
        {
          id: '41.10C',
          label: "4110C-Promotion immobilière d'autres bâtiments",
        },
        { id: '41.10D', label: '4110D-Supports juridiques de programmes' },
        { id: '41.20A', label: '4120A-Construction de maisons individuelles' },
        { id: '41.20B', label: "4120B-Construction d'autres bâtiments" },
        { id: '42.11Z', label: '4211Z-Construction de routes et autoroutes' },
        {
          id: '42.12Z',
          label:
            '4212Z-Construction de voies ferrées de surface et souterraines',
        },
        { id: '42.13A', label: "4213A-Construction d'ouvrages d'art" },
        { id: '42.13B', label: '4213B-Construction et entretien de tunnels' },
        { id: '42.21Z', label: '4221Z-Construction de réseaux pour fluides' },
        {
          id: '42.22Z',
          label:
            '4222Z-Construction de réseaux électriques et de télécommunications',
        },
        {
          id: '42.91Z',
          label: "4291Z-Construction d'ouvrages maritimes et fluviaux",
        },
        {
          id: '42.99Z',
          label: "4299Z-Construction d'autres ouvrages de génie civil nca",
        },
        { id: '43.11Z', label: '4311Z-Travaux de démolition' },
        {
          id: '43.12A',
          label:
            '4312A-Travaux de terrassement courants et travaux préparatoires',
        },
        {
          id: '43.12B',
          label: '4312B-Travaux de terrassement spécialisés ou de grande masse',
        },
        { id: '43.13Z', label: '4313Z-Forages et sondages' },
        {
          id: '43.21A',
          label: "4321A-Travaux d'installation électrique dans tous locaux",
        },
        {
          id: '43.21B',
          label: "4321B-Travaux d'installation électrique sur la voie publique",
        },
        {
          id: '43.22A',
          label: "4322A-Travaux d'installation d'eau et de gaz en tous locaux",
        },
        {
          id: '43.22B',
          label:
            "4322B-Travaux d' installation d'équipements thermiques et de climatisation",
        },
        { id: '43.29A', label: "4329A-Travaux d'isolation" },
        { id: '43.29B', label: "4329B-Autres travaux d'installation nca" },
        { id: '43.31Z', label: '4331Z-Travaux de plâtrerie' },
        { id: '43.32A', label: '4332A-Travaux de menuiserie bois et PVC' },
        {
          id: '43.32B',
          label: '4332B-Travaux de menuiserie métallique et serrurerie',
        },
        { id: '43.32C', label: '4332C-Agencement de lieux de vente' },
        {
          id: '43.33Z',
          label: '4333Z-Travaux de revêtement des sols et des murs',
        },
        { id: '43.34Z', label: '4334Z-Travaux de peinture et vitrerie' },
        { id: '43.39Z', label: '4339Z-Autres travaux de finition' },
        { id: '43.91A', label: '4391A-Travaux de charpente' },
        { id: '43.91B', label: '4391B-Travaux de couverture par éléments' },
        { id: '43.99A', label: "4399A-Travaux d'étanchéification" },
        {
          id: '43.99B',
          label: '4399B-Travaux de montage de structures métalliques',
        },
        {
          id: '43.99C',
          label:
            '4399C-Travaux de maçonnerie générale et gros œuvre de bâtiment',
        },
        {
          id: '43.99D',
          label: '4399D-Autres travaux spécialisés de construction',
        },
        {
          id: '43.99E',
          label: '4399E-Location avec opérateur de matériel de construction',
        },
        {
          id: '45.11Z',
          label:
            '4511Z-Commerce de voitures et de véhicules automobiles légers',
        },
        {
          id: '45.19Z',
          label: "4519Z-Commerce d'autres véhicules automobiles",
        },
        {
          id: '45.20A',
          label:
            '4520A-Entretien et réparation de véhicules automobiles légers',
        },
        {
          id: '45.20B',
          label: "4520B-Entretien et réparation d'autres véhicules automobiles",
        },
        {
          id: '45.31Z',
          label: "4531Z-Commerce de gros d'équipements automobiles",
        },
        {
          id: '45.32Z',
          label: "4532Z-Commerce de détail d'équipements automobiles",
        },
        { id: '45.40Z', label: '4540Z-Commerce et réparation de motocycles' },
        {
          id: '46.11Z',
          label:
            '4611Z-Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis',
        },
        { id: '46.12A', label: "4612A-Centrales d'achat de carburant" },
        {
          id: '46.12B',
          label:
            '4612B-Autres intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques',
        },
        {
          id: '46.13Z',
          label:
            '4613Z-Intermédiaires du commerce en bois et matériaux de construction',
        },
        {
          id: '46.14Z',
          label:
            '4614Z-Intermédiaires du commerce en machines, équipements industriels, navires et avions',
        },
        {
          id: '46.15Z',
          label:
            '4615Z-Intermédiaires du commerce en meubles, articles de ménage et quincaillerie',
        },
        {
          id: '46.16Z',
          label:
            '4616Z-Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir',
        },
        { id: '46.17A', label: "4617A-Centrales d'achat alimentaires" },
        {
          id: '46.17B',
          label:
            '4617B-Autres intermédiaires du commerce en denrées, boissons et tabac',
        },
        {
          id: '46.18Z',
          label:
            "4618Z-Intermédiaires spécialisés dans le commerce d'autres produits spécifiques",
        },
        { id: '46.19A', label: "4619A-Centrales d'achat non alimentaires" },
        {
          id: '46.19B',
          label: '4619B-Autres intermédiaires du commerce en produits divers',
        },
        {
          id: '46.21Z',
          label:
            "4621Z-Commerce de gros (commerce interentreprises) de céréales, de tabac non manufacturé, de semences et d'aliments pour le bétail",
        },
        {
          id: '46.22Z',
          label:
            '4622Z-Commerce de gros (commerce interentreprises) de fleurs et plantes',
        },
        {
          id: '46.23Z',
          label:
            "4623Z-Commerce de gros (commerce interentreprises) d'animaux vivants",
        },
        {
          id: '46.24Z',
          label:
            '4624Z-Commerce de gros (commerce interentreprises) de cuirs et peaux',
        },
        {
          id: '46.31Z',
          label:
            '4631Z-Commerce de gros (commerce interentreprises) de fruits et légumes',
        },
        {
          id: '46.32A',
          label:
            '4632A-Commerce de gros (commerce interentreprises) de viandes de boucherie',
        },
        {
          id: '46.32B',
          label:
            '4632B-Commerce de gros (commerce interentreprises) de produits à base de viande',
        },
        {
          id: '46.32C',
          label:
            '4632C-Commerce de gros (commerce interentreprises) de volailles et gibier',
        },
        {
          id: '46.33Z',
          label:
            '4633Z-Commerce de gros (commerce interentreprises) de produits laitiers, œufs, huiles et matières grasses comestibles',
        },
        {
          id: '46.34Z',
          label:
            '4634Z-Commerce de gros (commerce interentreprises) de boissons',
        },
        {
          id: '46.35Z',
          label:
            '4635Z-Commerce de gros (commerce interentreprises) de produits à base de tabac',
        },
        {
          id: '46.36Z',
          label:
            '4636Z-Commerce de gros (commerce interentreprises) de sucre, chocolat et confiserie',
        },
        {
          id: '46.37Z',
          label:
            '4637Z-Commerce de gros (commerce interentreprises) de café, thé, cacao et épices',
        },
        {
          id: '46.38A',
          label:
            '4638A-Commerce de gros (commerce interentreprises) de poissons, crustacés et mollusques',
        },
        {
          id: '46.38B',
          label:
            '4638B-Commerce de gros (commerce interentreprises) alimentaire spécialisé divers',
        },
        {
          id: '46.39A',
          label:
            '4639A-Commerce de gros (commerce interentreprises) de produits surgelés',
        },
        {
          id: '46.39B',
          label:
            '4639B-Commerce de gros (commerce interentreprises) alimentaire non spécialisé',
        },
        {
          id: '46.41Z',
          label:
            '4641Z-Commerce de gros (commerce interentreprises) de textiles',
        },
        {
          id: '46.42Z',
          label:
            "4642Z-Commerce de gros (commerce interentreprises) d'habillement et de chaussures",
        },
        {
          id: '46.43Z',
          label:
            "4643Z-Commerce de gros (commerce interentreprises) d'appareils électroménagers",
        },
        {
          id: '46.44Z',
          label:
            "4644Z-Commerce de gros (commerce interentreprises) de vaisselle, verrerie et produits d'entretien",
        },
        {
          id: '46.45Z',
          label:
            '4645Z-Commerce de gros (commerce interentreprises) de parfumerie et de produits de beauté',
        },
        {
          id: '46.46Z',
          label:
            '4646Z-Commerce de gros (commerce interentreprises) de produits pharmaceutiques',
        },
        {
          id: '46.47Z',
          label:
            "4647Z-Commerce de gros (commerce interentreprises) de meubles, de tapis et d'appareils d'éclairage",
        },
        {
          id: '46.48Z',
          label:
            "4648Z-Commerce de gros (commerce interentreprises) d'articles d'horlogerie et de bijouterie",
        },
        {
          id: '46.49Z',
          label:
            "4649Z-Commerce de gros (commerce interentreprises) d'autres biens domestiques",
        },
        {
          id: '46.51Z',
          label:
            "4651Z-Commerce de gros (commerce interentreprises) d'ordinateurs, d'équipements informatiques périphériques et de logiciels",
        },
        {
          id: '46.52Z',
          label:
            "4652Z-Commerce de gros (commerce interentreprises) de composants et d'équipements électroniques et de télécommunication",
        },
        {
          id: '46.61Z',
          label:
            '4661Z-Commerce de gros (commerce interentreprises) de matériel agricole',
        },
        {
          id: '46.62Z',
          label:
            '4662Z-Commerce de gros (commerce interentreprises) de machines-outils',
        },
        {
          id: '46.63Z',
          label:
            "4663Z-Commerce de gros (commerce interentreprises) de machines pour l'extraction, la construction et le génie civil",
        },
        {
          id: '46.64Z',
          label:
            "4664Z-Commerce de gros (commerce interentreprises) de machines pour l'industrie textile et l'habillement",
        },
        {
          id: '46.65Z',
          label:
            '4665Z-Commerce de gros (commerce interentreprises) de mobilier de bureau',
        },
        {
          id: '46.66Z',
          label:
            "4666Z-Commerce de gros (commerce interentreprises) d'autres machines et équipements de bureau",
        },
        {
          id: '46.69A',
          label:
            '4669A-Commerce de gros (commerce interentreprises) de matériel électrique',
        },
        {
          id: '46.69B',
          label:
            '4669B-Commerce de gros (commerce interentreprises) de fournitures et équipements industriels divers',
        },
        {
          id: '46.69C',
          label:
            '4669C-Commerce de gros (commerce interentreprises) de fournitures et équipements divers pour le commerce et les services',
        },
        {
          id: '46.71Z',
          label:
            '4671Z-Commerce de gros (commerce interentreprises) de combustibles et de produits annexes',
        },
        {
          id: '46.72Z',
          label:
            '4672Z-Commerce de gros (commerce interentreprises) de minerais et métaux',
        },
        {
          id: '46.73A',
          label:
            '4673A-Commerce de gros (commerce interentreprises) de bois et de matériaux de construction',
        },
        {
          id: '46.73B',
          label:
            "4673B-Commerce de gros (commerce interentreprises) d'appareils sanitaires et de produits de décoration",
        },
        {
          id: '46.74A',
          label:
            '4674A-Commerce de gros (commerce interentreprises) de quincaillerie',
        },
        {
          id: '46.74B',
          label:
            '4674B-Commerce de gros (commerce interentreprises) de fournitures pour la plomberie et le chauffage',
        },
        {
          id: '46.75Z',
          label:
            '4675Z-Commerce de gros (commerce interentreprises) de produits chimiques',
        },
        {
          id: '46.76Z',
          label:
            "4676Z-Commerce de gros (commerce interentreprises) d'autres produits intermédiaires",
        },
        {
          id: '46.77Z',
          label:
            '4677Z-Commerce de gros (commerce interentreprises) de déchets et débris',
        },
        {
          id: '46.90Z',
          label:
            '4690Z-Commerce de gros (commerce interentreprises) non spécialisé',
        },
        {
          id: '47.11A',
          label: '4711A-Commerce de détail de produits surgelés',
        },
        { id: '47.11B', label: "4711B-Commerce d'alimentation générale" },
        { id: '47.11C', label: '4711C-Supérettes' },
        { id: '47.11D', label: '4711D-Supermarchés' },
        { id: '47.11E', label: '4711E-Magasins multi-commerces' },
        { id: '47.11F', label: '4711F-Hypermarchés' },
        { id: '47.19A', label: '4719A-Grands magasins' },
        {
          id: '47.19B',
          label: '4719B-Autres commerces de détail en magasin non spécialisé',
        },
        {
          id: '47.21Z',
          label:
            '4721Z-Commerce de détail de fruits et légumes en magasin spécialisé',
        },
        {
          id: '47.22Z',
          label:
            '4722Z-Commerce de détail de viandes et de produits à base de viande en magasin spécialisé',
        },
        {
          id: '47.23Z',
          label:
            '4723Z-Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé',
        },
        {
          id: '47.24Z',
          label:
            '4724Z-Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé',
        },
        {
          id: '47.25Z',
          label: '4725Z-Commerce de détail de boissons en magasin spécialisé',
        },
        {
          id: '47.26Z',
          label:
            '4726Z-Commerce de détail de produits à base de tabac en magasin spécialisé',
        },
        {
          id: '47.29Z',
          label:
            '4729Z-Autres commerces de détail alimentaires en magasin spécialisé',
        },
        {
          id: '47.30Z',
          label: '4730Z-Commerce de détail de carburants en magasin spécialisé',
        },
        {
          id: '47.41Z',
          label:
            "4741Z-Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé",
        },
        {
          id: '47.42Z',
          label:
            '4742Z-Commerce de détail de matériels de télécommunication en magasin spécialisé',
        },
        {
          id: '47.43Z',
          label:
            '4743Z-Commerce de détail de matériels audio et vidéo en magasin spécialisé',
        },
        {
          id: '47.51Z',
          label: '4751Z-Commerce de détail de textiles en magasin spécialisé',
        },
        {
          id: '47.52A',
          label:
            '4752A-Commerce de détail de quincaillerie, peintures et verres en petites surfaces (moins de 400 m2)',
        },
        {
          id: '47.52B',
          label:
            '4752B-Commerce de détail de quincaillerie, peintures et verres en grandes surfaces (400 m2 et plus)',
        },
        {
          id: '47.53Z',
          label:
            '4753Z-Commerce de détail de tapis, moquettes et revêtements de murs et de sols en magasin spécialisé',
        },
        {
          id: '47.54Z',
          label:
            "4754Z-Commerce de détail d'appareils électroménagers en magasin spécialisé",
        },
        { id: '47.59A', label: '4759A-Commerce de détail de meubles' },
        {
          id: '47.59B',
          label: "4759B-Commerce de détail d'autres équipements du foyer",
        },
        {
          id: '47.61Z',
          label: '4761Z-Commerce de détail de livres en magasin spécialisé',
        },
        {
          id: '47.62Z',
          label:
            '4762Z-Commerce de détail de journaux et papeterie en magasin spécialisé',
        },
        {
          id: '47.63Z',
          label:
            "4763Z-Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé",
        },
        {
          id: '47.64Z',
          label:
            "4764Z-Commerce de détail d'articles de sport en magasin spécialisé",
        },
        {
          id: '47.65Z',
          label:
            '4765Z-Commerce de détail de jeux et jouets en magasin spécialisé',
        },
        {
          id: '47.71Z',
          label: "4771Z-Commerce de détail d'habillement en magasin spécialisé",
        },
        { id: '47.72A', label: '4772A-Commerce de détail de la chaussure' },
        {
          id: '47.72B',
          label:
            "4772B-Commerce de détail de maroquinerie et d'articles de voyage",
        },
        {
          id: '47.73Z',
          label:
            '4773Z-Commerce de détail de produits pharmaceutiques en magasin spécialisé',
        },
        {
          id: '47.74Z',
          label:
            "4774Z-Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé",
        },
        {
          id: '47.75Z',
          label:
            '4775Z-Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé',
        },
        {
          id: '47.76Z',
          label:
            '4776Z-Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé',
        },
        {
          id: '47.77Z',
          label:
            "4777Z-Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé",
        },
        { id: '47.78A', label: "4778A-Commerces de détail d'optique" },
        {
          id: '47.78B',
          label: '4778B-Commerces de détail de charbons et combustibles',
        },
        {
          id: '47.78C',
          label: '4778C-Autres commerces de détail spécialisés divers',
        },
        {
          id: '47.79Z',
          label: "4779Z-Commerce de détail de biens d'occasion en magasin",
        },
        {
          id: '47.81Z',
          label:
            '4781Z-Commerce de détail alimentaire sur éventaires et marchés',
        },
        {
          id: '47.82Z',
          label:
            "4782Z-Commerce de détail de textiles, d'habillement et de chaussures sur éventaires et marchés",
        },
        {
          id: '47.89Z',
          label: '4789Z-Autres commerces de détail sur éventaires et marchés',
        },
        { id: '47.91A', label: '4791A-Vente à distance sur catalogue général' },
        {
          id: '47.91B',
          label: '4791B-Vente à distance sur catalogue spécialisé',
        },
        { id: '47.99A', label: '4799A-Vente à domicile' },
        {
          id: '47.99B',
          label:
            '4799B-Vente par automates et autres commerces de détail hors magasin, éventaires ou marchés nca',
        },
        {
          id: '49.10Z',
          label: '4910Z-Transport ferroviaire interurbain de voyageurs',
        },
        { id: '49.20Z', label: '4920Z-Transports ferroviaires de fret' },
        {
          id: '49.31Z',
          label: '4931Z-Transports urbains et suburbains de voyageurs',
        },
        { id: '49.32Z', label: '4932Z-Transports de voyageurs par taxis' },
        {
          id: '49.39A',
          label: '4939A-Transports routiers réguliers de voyageurs',
        },
        {
          id: '49.39B',
          label: '4939B-Autres transports routiers de voyageurs',
        },
        { id: '49.39C', label: '4939C-Téléphériques et remontées mécaniques' },
        {
          id: '49.41A',
          label: '4941A-Transports routiers de fret interurbains',
        },
        {
          id: '49.41B',
          label: '4941B-Transports routiers de fret de proximité',
        },
        { id: '49.41C', label: '4941C-Location de camions avec chauffeur' },
        { id: '49.42Z', label: '4942Z-Services de déménagement' },
        { id: '49.50Z', label: '4950Z-Transports par conduites' },
        {
          id: '50.10Z',
          label: '5010Z-Transports maritimes et côtiers de passagers',
        },
        {
          id: '50.20Z',
          label: '5020Z-Transports maritimes et côtiers de fret',
        },
        { id: '50.30Z', label: '5030Z-Transports fluviaux de passagers' },
        { id: '50.40Z', label: '5040Z-Transports fluviaux de fret' },
        { id: '51.10Z', label: '5110Z-Transports aériens de passagers' },
        { id: '51.21Z', label: '5121Z-Transports aériens de fret' },
        { id: '51.22Z', label: '5122Z-Transports spatiaux' },
        { id: '52.10A', label: '5210A-Entreposage et stockage frigorifique' },
        {
          id: '52.10B',
          label: '5210B-Entreposage et stockage non frigorifique',
        },
        {
          id: '52.21Z',
          label: '5221Z-Services auxiliaires des transports terrestres',
        },
        {
          id: '52.22Z',
          label: '5222Z-Services auxiliaires des transports par eau',
        },
        {
          id: '52.23Z',
          label: '5223Z-Services auxiliaires des transports aériens',
        },
        { id: '52.24A', label: '5224A-Manutention portuaire' },
        { id: '52.24B', label: '5224B-Manutention non portuaire' },
        { id: '52.29A', label: '5229A-Messagerie, fret express' },
        {
          id: '52.29B',
          label: '5229B-Affrètement et organisation des transports',
        },
        {
          id: '53.10Z',
          label:
            "5310Z-Activités de poste dans le cadre d'une obligation de service universel",
        },
        {
          id: '53.20Z',
          label: '5320Z-Autres activités de poste et de courrier',
        },
        { id: '55.10Z', label: '5510Z-Hôtels et hébergement similaire' },
        {
          id: '55.20Z',
          label:
            '5520Z-Hébergement touristique et autre hébergement de courte durée',
        },
        {
          id: '55.30Z',
          label:
            '5530Z-Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
        },
        { id: '55.90Z', label: '5590Z-Autres hébergements' },
        { id: '56.10A', label: '5610A-Restauration traditionnelle' },
        { id: '56.10B', label: '5610B-Cafétérias et autres libres-services' },
        { id: '56.10C', label: '5610C-Restauration de type rapide' },
        { id: '56.21Z', label: '5621Z-Services des traiteurs' },
        { id: '56.29A', label: '5629A-Restauration collective sous contrat' },
        { id: '56.29B', label: '5629B-Autres services de restauration nca' },
        { id: '56.30Z', label: '5630Z-Débits de boissons' },
        { id: '58.11Z', label: '5811Z-Édition de livres' },
        {
          id: '58.12Z',
          label: "5812Z-Édition de répertoires et de fichiers d'adresses",
        },
        { id: '58.13Z', label: '5813Z-Édition de journaux' },
        { id: '58.14Z', label: '5814Z-Édition de revues et périodiques' },
        { id: '58.19Z', label: "5819Z-Autres activités d'édition" },
        { id: '58.21Z', label: '5821Z-Édition de jeux électroniques' },
        {
          id: '58.29A',
          label: '5829A-Édition de logiciels système et de réseau',
        },
        {
          id: '58.29B',
          label:
            '5829B-Edition de logiciels outils de développement et de langages',
        },
        { id: '58.29C', label: '5829C-Edition de logiciels applicatifs' },
        {
          id: '59.11A',
          label:
            '5911A-Production de films et de programmes pour la télévision',
        },
        {
          id: '59.11B',
          label: '5911B-Production de films institutionnels et publicitaires',
        },
        { id: '59.11C', label: '5911C-Production de films pour le cinéma' },
        {
          id: '59.12Z',
          label:
            '5912Z-Post-production de films cinématographiques, de vidéo et de programmes de télévision',
        },
        {
          id: '59.13A',
          label: '5913A-Distribution de films cinématographiques',
        },
        { id: '59.13B', label: '5913B-Edition et distribution vidéo' },
        { id: '59.14Z', label: '5914Z-Projection de films cinématographiques' },
        {
          id: '59.20Z',
          label: '5920Z-Enregistrement sonore et édition musicale',
        },
        {
          id: '60.10Z',
          label: '6010Z-Édition et diffusion de programmes radio',
        },
        { id: '60.20A', label: '6020A-Edition de chaînes généralistes' },
        { id: '60.20B', label: '6020B-Edition de chaînes thématiques' },
        { id: '61.10Z', label: '6110Z-Télécommunications filaires' },
        { id: '61.20Z', label: '6120Z-Télécommunications sans fil' },
        { id: '61.30Z', label: '6130Z-Télécommunications par satellite' },
        { id: '61.90Z', label: '6190Z-Autres activités de télécommunication' },
        { id: '62.01Z', label: '6201Z-Programmation informatique' },
        {
          id: '62.02A',
          label: '6202A-Conseil en systèmes et logiciels informatiques',
        },
        {
          id: '62.02B',
          label:
            '6202B-Tierce maintenance de systèmes et d’applications informatiques',
        },
        { id: '62.03Z', label: "6203Z-Gestion d'installations informatiques" },
        { id: '62.09Z', label: '6209Z-Autres activités informatiques' },
        {
          id: '63.11Z',
          label:
            '6311Z-Traitement de données, hébergement et activités connexes',
        },
        { id: '63.12Z', label: '6312Z-Portails Internet' },
        { id: '63.91Z', label: '6391Z-Activités des agences de presse' },
        { id: '63.99Z', label: "6399Z-Autres services d'information nca" },
        { id: '64.11Z', label: '6411Z-Activités de banque centrale' },
        { id: '64.19Z', label: '6419Z-Autres intermédiations monétaires' },
        { id: '64.20Z', label: '6420Z-Activités des sociétés holding' },
        {
          id: '64.30Z',
          label: '6430Z-Fonds de placement et entités financières similaires',
        },
        { id: '64.91Z', label: '6491Z-Crédit-bail' },
        { id: '64.92Z', label: '6492Z-Autre distribution de crédit' },
        {
          id: '64.99Z',
          label:
            '6499Z-Autres activités des services financiers, hors assurance et caisses de retraite, nca',
        },
        { id: '65.11Z', label: '6511Z-Assurance vie' },
        { id: '65.12Z', label: '6512Z-Autres assurances' },
        { id: '65.20Z', label: '6520Z-Réassurance' },
        { id: '65.30Z', label: '6530Z-Caisses de retraite' },
        { id: '66.11Z', label: '6611Z-Administration de marchés financiers' },
        {
          id: '66.12Z',
          label: '6612Z-Courtage de valeurs mobilières et de marchandises',
        },
        {
          id: '66.19A',
          label: '6619A-Supports juridiques de gestion de patrimoine mobilier',
        },
        {
          id: '66.19B',
          label:
            '6619B-Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite, nca',
        },
        { id: '66.21Z', label: '6621Z-Évaluation des risques et dommages' },
        {
          id: '66.22Z',
          label: "6622Z-Activités des agents et courtiers d'assurances",
        },
        {
          id: '66.29Z',
          label:
            "6629Z-Autres activités auxiliaires d'assurance et de caisses de retraite",
        },
        { id: '66.30Z', label: '6630Z-Gestion de fonds' },
        {
          id: '68.10Z',
          label: '6810Z-Activités des marchands de biens immobiliers',
        },
        { id: '68.20A', label: '6820A-Location de logements' },
        {
          id: '68.20B',
          label: "6820B-Location de terrains et d'autres biens immobiliers",
        },
        { id: '68.31Z', label: '6831Z-Agences immobilières' },
        {
          id: '68.32A',
          label: "6832A-Administration d'immeubles et autres biens immobiliers",
        },
        {
          id: '68.32B',
          label:
            '6832B-Supports juridiques de gestion de patrimoine immobilier',
        },
        { id: '69.10Z', label: '6910Z-Activités juridiques' },
        { id: '69.20Z', label: '6920Z-Activités comptables' },
        { id: '70.10Z', label: '7010Z-Activités des sièges sociaux' },
        {
          id: '70.21Z',
          label: '7021Z-Conseil en relations publiques et communication',
        },
        {
          id: '70.22Z',
          label:
            '7022Z-Conseil pour les affaires et autres conseils de gestion',
        },
        { id: '71.11Z', label: "7111Z-Activités d'architecture" },
        { id: '71.12A', label: '7112A-Activité des géomètres' },
        { id: '71.12B', label: '7112B-Ingénierie, études techniques' },
        { id: '71.20A', label: '7120A-Contrôle technique automobile' },
        {
          id: '71.20B',
          label: '7120B-Analyses, essais et inspections techniques',
        },
        {
          id: '72.11Z',
          label: '7211Z-Recherche-développement en biotechnologie',
        },
        {
          id: '72.19Z',
          label:
            '7219Z-Recherche-développement en autres sciences physiques et naturelles',
        },
        {
          id: '72.20Z',
          label:
            '7220Z-Recherche-développement en sciences humaines et sociales',
        },
        { id: '73.11Z', label: '7311Z-Activités des agences de publicité' },
        { id: '73.12Z', label: '7312Z-Régie publicitaire de médias' },
        { id: '73.20Z', label: '7320Z-Études de marché et sondages' },
        { id: '74.10Z', label: '7410Z-Activités spécialisées de design' },
        { id: '74.20Z', label: '7420Z-Activités photographiques' },
        { id: '74.30Z', label: '7430Z-Traduction et interprétation' },
        {
          id: '74.90A',
          label: '7490A-Activité des économistes de la construction',
        },
        {
          id: '74.90B',
          label:
            '7490B-Activités spécialisées, scientifiques et techniques diverses',
        },
        { id: '75.00Z', label: '7500Z-Activités vétérinaires' },
        {
          id: '77.11A',
          label:
            '7711A-Location de courte durée de voitures et de véhicules automobiles légers',
        },
        {
          id: '77.11B',
          label:
            '7711B-Location de longue durée de voitures et de véhicules automobiles légers',
        },
        { id: '77.12Z', label: '7712Z-Location et location-bail de camions' },
        {
          id: '77.21Z',
          label:
            "7721Z-Location et location-bail d'articles de loisirs et de sport",
        },
        {
          id: '77.22Z',
          label: '7722Z-Location de vidéocassettes et disques vidéo',
        },
        {
          id: '77.29Z',
          label:
            "7729Z-Location et location-bail d'autres biens personnels et domestiques",
        },
        {
          id: '77.31Z',
          label:
            '7731Z-Location et location-bail de machines et équipements agricoles',
        },
        {
          id: '77.32Z',
          label:
            '7732Z-Location et location-bail de machines et équipements pour la construction',
        },
        {
          id: '77.33Z',
          label:
            '7733Z-Location et location-bail de machines de bureau et de matériel informatique',
        },
        {
          id: '77.34Z',
          label:
            '7734Z-Location et location-bail de matériels de transport par eau',
        },
        {
          id: '77.35Z',
          label:
            '7735Z-Location et location-bail de matériels de transport aérien',
        },
        {
          id: '77.39Z',
          label:
            "7739Z-Location et location-bail d'autres machines, équipements et biens matériels nca",
        },
        {
          id: '77.40Z',
          label:
            "7740Z-Location-bail de propriété intellectuelle et de produits similaires, à l'exception des œuvres soumises à copyright",
        },
        {
          id: '78.10Z',
          label: "7810Z-Activités des agences de placement de main-d'œuvre",
        },
        {
          id: '78.20Z',
          label: '7820Z-Activités des agences de travail temporaire',
        },
        {
          id: '78.30Z',
          label: '7830Z-Autre mise à disposition de ressources humaines',
        },
        { id: '79.11Z', label: '7911Z-Activités des agences de voyage' },
        { id: '79.12Z', label: '7912Z-Activités des voyagistes' },
        {
          id: '79.90Z',
          label: '7990Z-Autres services de réservation et activités connexes',
        },
        { id: '80.10Z', label: '8010Z-Activités de sécurité privée' },
        {
          id: '80.20Z',
          label: '8020Z-Activités liées aux systèmes de sécurité',
        },
        { id: '80.30Z', label: "8030Z-Activités d'enquête" },
        {
          id: '81.10Z',
          label: '8110Z-Activités combinées de soutien lié aux bâtiments',
        },
        { id: '81.21Z', label: '8121Z-Nettoyage courant des bâtiments' },
        {
          id: '81.22Z',
          label:
            '8122Z-Autres activités de nettoyage des bâtiments et nettoyage industriel',
        },
        {
          id: '81.29A',
          label: '8129A-Désinfection, désinsectisation, dératisation',
        },
        { id: '81.29B', label: '8129B-Autres activités de nettoyage nca' },
        { id: '81.30Z', label: "8130Z-Services d'aménagement paysager" },
        {
          id: '82.11Z',
          label: '8211Z-Services administratifs combinés de bureau',
        },
        {
          id: '82.19Z',
          label:
            '8219Z-Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau',
        },
        { id: '82.20Z', label: "8220Z-Activités de centres d'appels" },
        {
          id: '82.30Z',
          label:
            '8230Z-Organisation de foires, salons professionnels et congrès',
        },
        {
          id: '82.91Z',
          label:
            "8291Z-Activités des agences de recouvrement de factures et des sociétés d'information financière sur la clientèle",
        },
        { id: '82.92Z', label: '8292Z-Activités de conditionnement' },
        {
          id: '82.99Z',
          label: '8299Z-Autres activités de soutien aux entreprises nca',
        },
        { id: '84.11Z', label: '8411Z-Administration publique générale' },
        {
          id: '84.12Z',
          label:
            '8412Z-Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale',
        },
        {
          id: '84.13Z',
          label:
            '8413Z-Administration publique (tutelle) des activités économiques',
        },
        { id: '84.21Z', label: '8421Z-Affaires étrangères' },
        { id: '84.22Z', label: '8422Z-Défense' },
        { id: '84.23Z', label: '8423Z-Justice' },
        {
          id: '84.24Z',
          label: '8424Z-Activités d’ordre public et de sécurité',
        },
        { id: '84.25Z', label: '8425Z-Services du feu et de secours' },
        {
          id: '84.30A',
          label: '8430A-Activités générales de sécurité sociale',
        },
        { id: '84.30B', label: '8430B-Gestion des retraites complémentaires' },
        { id: '84.30C', label: '8430C-Distribution sociale de revenus' },
        { id: '85.10Z', label: '8510Z-Enseignement pré-primaire' },
        { id: '85.20Z', label: '8520Z-Enseignement primaire' },
        { id: '85.31Z', label: '8531Z-Enseignement secondaire général' },
        {
          id: '85.32Z',
          label: '8532Z-Enseignement secondaire technique ou professionnel',
        },
        {
          id: '85.41Z',
          label: '8541Z-Enseignement post-secondaire non supérieur',
        },
        { id: '85.42Z', label: '8542Z-Enseignement supérieur' },
        {
          id: '85.51Z',
          label:
            "8551Z-Enseignement de disciplines sportives et d'activités de loisirs",
        },
        { id: '85.52Z', label: '8552Z-Enseignement culturel' },
        { id: '85.53Z', label: '8553Z-Enseignement de la conduite' },
        { id: '85.59A', label: "8559A-Formation continue d'adultes" },
        { id: '85.59B', label: '8559B-Autres enseignements' },
        { id: '85.60Z', label: "8560Z-Activités de soutien à l'enseignement" },
        { id: '86.10Z', label: '8610Z-Activités hospitalières' },
        { id: '86.21Z', label: '8621Z-Activité des médecins généralistes' },
        {
          id: '86.22A',
          label: '8622A-Activités de radiodiagnostic et de radiothérapie',
        },
        { id: '86.22B', label: '8622B-Activités chirurgicales' },
        {
          id: '86.22C',
          label: '8622C-Autres activités des médecins spécialistes',
        },
        { id: '86.23Z', label: '8623Z-Pratique dentaire' },
        { id: '86.90A', label: '8690A-Ambulances' },
        { id: '86.90B', label: "8690B-Laboratoires d'analyses médicales" },
        {
          id: '86.90C',
          label: "8690C-Centres de collecte et banques d'organes",
        },
        {
          id: '86.90D',
          label: '8690D-Activités des infirmiers et des sages-femmes',
        },
        {
          id: '86.90E',
          label:
            '8690E-Activités des professionnels de la rééducation, de l’appareillage et des pédicures-podologues',
        },
        {
          id: '86.90F',
          label: '8690F-Activités de santé humaine non classées ailleurs',
        },
        {
          id: '87.10A',
          label: '8710A-Hébergement médicalisé pour personnes âgées',
        },
        {
          id: '87.10B',
          label: '8710B-Hébergement médicalisés pour enfants handicapés',
        },
        {
          id: '87.10C',
          label:
            '8710C-Hébergement médicalisé pour adultes handicapés et autre hébergement médicalisé',
        },
        {
          id: '87.20A',
          label:
            '8720A-Hébergement social pour handicapés mentaux et malades mentaux',
        },
        { id: '87.20B', label: '8720B-Hébergement social pour toxicomanes' },
        {
          id: '87.30A',
          label: '8730A-Hébergement social pour personnes âgées',
        },
        {
          id: '87.30B',
          label: '8730B-Hébergement social pour handicapés physiques',
        },
        {
          id: '87.90A',
          label: '8790A-Hébergement social pour enfants en difficultés',
        },
        {
          id: '87.90B',
          label:
            '8790B-Hébergement social pour adultes et familles en difficultés et autre hébergement social',
        },
        { id: '88.10A', label: '8810A-Aide à domicile' },
        {
          id: '88.10B',
          label:
            '8810B-Accueil ou accompagnement sans hébergement d’adultes handicapés ou de personnes âgées',
        },
        { id: '88.10C', label: '8810C-Aide par le travail' },
        { id: '88.91A', label: '8891A-Accueil de jeunes enfants' },
        {
          id: '88.91B',
          label:
            '8891B-Accueil ou accompagnement sans hébergement d’enfants handicapés',
        },
        {
          id: '88.99A',
          label:
            '8899A-Autre accueil ou accompagnement sans hébergement ?_x0019_enfants et d’adolescents',
        },
        { id: '88.99B', label: '8899B-Action sociale sans hébergement nca' },
        { id: '90.01Z', label: '9001Z-Arts du spectacle vivant' },
        {
          id: '90.02Z',
          label: '9002Z-Activités de soutien au spectacle vivant',
        },
        {
          id: '90.03A',
          label: '9003A-Création artistique relevant des arts plastiques',
        },
        { id: '90.03B', label: '9003B-Autre création artistique' },
        { id: '90.04Z', label: '9004Z-Gestion de salles de spectacles' },
        {
          id: '91.01Z',
          label: '9101Z-Gestion des bibliothèques et des archives',
        },
        { id: '91.02Z', label: '9102Z-Gestion des musées' },
        {
          id: '91.03Z',
          label:
            '9103Z-Gestion des sites et monuments historiques et des attractions touristiques similaires',
        },
        {
          id: '91.04Z',
          label:
            '9104Z-Gestion des jardins botaniques et zoologiques et des réserves naturelles',
        },
        {
          id: '92.00Z',
          label: "9200Z-Organisation de jeux de hasard et d'argent",
        },
        { id: '93.11Z', label: "9311Z-Gestion d'installations sportives" },
        { id: '93.12Z', label: '9312Z-Activités de clubs de sports' },
        {
          id: '93.13Z',
          label: '9313Z-Activités des centres de culture physique',
        },
        { id: '93.19Z', label: '9319Z-Autres activités liées au sport' },
        {
          id: '93.21Z',
          label: "9321Z-Activités des parcs d'attractions et parcs à thèmes",
        },
        {
          id: '93.29Z',
          label: '9329Z-Autres activités récréatives et de loisirs',
        },
        {
          id: '94.11Z',
          label: '9411Z-Activités des organisations patronales et consulaires',
        },
        {
          id: '94.12Z',
          label: '9412Z-Activités des organisations professionnelles',
        },
        { id: '94.20Z', label: '9420Z-Activités des syndicats de salariés' },
        {
          id: '94.91Z',
          label: '9491Z-Activités des organisations religieuses',
        },
        { id: '94.92Z', label: '9492Z-Activités des organisations politiques' },
        {
          id: '94.99Z',
          label:
            '9499Z-Autres organisations fonctionnant par adhésion volontaire',
        },
        {
          id: '95.11Z',
          label:
            "9511Z-Réparation d'ordinateurs et d'équipements périphériques",
        },
        {
          id: '95.12Z',
          label: "9512Z-Réparation d'équipements de communication",
        },
        {
          id: '95.21Z',
          label: '9521Z-Réparation de produits électroniques grand public',
        },
        {
          id: '95.22Z',
          label:
            "9522Z-Réparation d'appareils électroménagers et d'équipements pour la maison et le jardin",
        },
        {
          id: '95.23Z',
          label: "9523Z-Réparation de chaussures et d'articles en cuir",
        },
        {
          id: '95.24Z',
          label: "9524Z-Réparation de meubles et d'équipements du foyer",
        },
        {
          id: '95.25Z',
          label: "9525Z-Réparation d'articles d'horlogerie et de bijouterie",
        },
        {
          id: '95.29Z',
          label: "9529Z-Réparation d'autres biens personnels et domestiques",
        },
        { id: '96.01A', label: '9601A-Blanchisserie-teinturerie de gros' },
        { id: '96.01B', label: '9601B-Blanchisserie-teinturerie de détail' },
        { id: '96.02A', label: '9602A-Coiffure' },
        { id: '96.02B', label: '9602B-Soins de beauté' },
        { id: '96.03Z', label: '9603Z-Services funéraires' },
        { id: '96.04Z', label: '9604Z-Entretien corporel' },
        { id: '96.09Z', label: '9609Z-Autres services personnels nca' },
        {
          id: '97.00Z',
          label:
            "9700Z-Activités des ménages en tant qu'employeurs de personnel domestique",
        },
        {
          id: '98.10Z',
          label:
            '9810Z-Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
        },
        {
          id: '98.20Z',
          label:
            '9820Z-Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
        },
        {
          id: '99.00Z',
          label:
            '9900Z-Activités des organisations et organismes extraterritoriaux',
        },
      ],
    }
  },
  created() {},
})
export default function getCodeNaf() {
  return nafCodes
}
